import { Injectable, inject } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {BuildInfo} from "../domain/build-info.model";

@Injectable({
  providedIn: 'root',
})
export class BuildInfoService {
  private http = inject(HttpClient);

  private readonly url: string = '/api/build-info';

  getBuildInfo(): Observable<BuildInfo> {
    return this.http.get<BuildInfo>(this.url);
  }
}
